import { render, staticRenderFns } from "./SurfaceTensionViz.vue?vue&type=template&id=3f3c9f36&scoped=true"
import script from "./SurfaceTensionViz.vue?vue&type=script&lang=js"
export * from "./SurfaceTensionViz.vue?vue&type=script&lang=js"
import style0 from "./SurfaceTensionViz.vue?vue&type=style&index=0&id=3f3c9f36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3c9f36",
  null
  
)

export default component.exports